module.exports = __webpack_public_path__ + "static/media/WechatIMG3842.7b9341fb.jpg";